import React from "react";
import { SEO } from "@bluefin/components";
import { Grid, Segment } from "semantic-ui-react";
import { ProductBrowser } from "@ecwid/gatsby-plugin-ecwid";
import { graphql } from "gatsby";

import WebsiteLayout from "../components/WebsiteLayout.jsx";

export default class ShopSalon689Page extends React.PureComponent {
  render() {
    const { data } = this.props;
    const { fishermanBusiness, fishermanBusinessWebsitePage } = data;

    return (
      <WebsiteLayout>
        <SEO
          businessName={fishermanBusiness.name}
          pageName={fishermanBusinessWebsitePage.title}
          title={fishermanBusinessWebsitePage.seoTitle}
          description={fishermanBusinessWebsitePage.description}
          ogUrl={"https://www.salon689.com/shop-salon-689/"}
        />
        <Grid
          className={"custom-page-shop-salon-689 custom-page-grid"}
          style={{}}
          stackable={true}
        >
          <Grid.Row
            className={"ibhebcaogjfheemp"}
            style={{ padding: 16 }}
            columns={1}
          >
            <Grid.Column className={"aknmbbdbinhjehln"} style={{ padding: 16 }}>
              <Segment
                className={""}
                style={{
                  border: "none",
                  boxShadow: "none",
                  background: "none",
                }}
              >
                <React.Fragment
                  key={"JSON__07af7862-8a9f-4637-9e73-aee49add0959"}
                >
                  <ProductBrowser storeId={"128928013"} />
                </React.Fragment>
              </Segment>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </WebsiteLayout>
    );
  }
}

export const query = graphql`
  query {
    fishermanBusiness {
      name
    }
    fishermanBusinessWebsitePage(_id: { eq: 36286 }) {
      title
      seoTitle
      description
    }
  }
`;
